import styled from 'styled-components';
import { Tag } from 'antd';
import { ButtonWrapper, ButtonLabel } from '@src/styles/styled/mixins';

export const StyledTrendSelector = styled.div`
  display: flex;
  position: relative;
  justify-content: space-between;
  margin-left: 10px;
  border-right: 1px solid #D8D8D8;
  margin-right: 15px;
`;

export const StyledToggleWrapper = styled.div`
  width: 60px;
  margin: 5px;
`;

export const KebabWrapper = styled.div`
  line-height: 2;
`;

export const MetricTagsWrapper = styled.div`
  overflow: hidden;
  flex: 1;
  display: flex;
`;

export const TagWrapper = styled.div`
  display: flex;
  overflow: auto;
  flex: 1;
  gap: 5px;
  padding: 2px 0px;
  flex-wrap: wrap;
`;

export const StyledTag = styled(Tag)<{
  $namode?: boolean;
}>`
  font-size: 14px;
  padding: 5px 8px;
  margin: 0px;
  cursor: ${(props) => (props.$namode ? 'not-allowed' : 'pointer' )};
  background-color: #f5f5f5;
  align-self: center;
  position: relative;
  .anticon {
    font-size: 12px;
  }
`;

export const StyledResizeWrapper = styled.div`
  ${ButtonWrapper}
`;

export const StyledResizeLabel = styled.div`
  ${ButtonLabel}
`;

